import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Divider, Collapse } from 'antd';

import * as constants from '../constants';
import {
    loadReleaseNotes
} from '../actions';

import uistate from '../../uistate';
import common from '../../../common';

class ReleaseNotesStartScreen extends Component {

    state = {
        releasenotes: [],
    }

    async UNSAFE_componentWillMount() {
        let res = await this.props.loadReleaseNotes(this.props.curLanguage);
        this.setState({ releasenotes: res.data });
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ReleaseNotesStartScreen', key);
    }

    render() {
        let relnotes = [];
        let defaultActiveReleaseNote = '';
        if (this.state.releasenotes.length > 0) {
            defaultActiveReleaseNote = this.state.releasenotes[0].idReleaseNote.toString();
            relnotes = this.state.releasenotes.map(r => ({
                key: r.idReleaseNote.toString(),
                label: <span style={{ color: '#0091dc', fontWeight: 'bold' }}>{r.title}</span>,
                children: <div className='startscreen' dangerouslySetInnerHTML={{ __html: r.value }}></div>,
            }));
        }
        return (
            <>
                {this.state.releasenotes.length > 0 &&
                    <>
                        <Divider />
                        <span className='module-title'>{this.label("ReleaseNotes")}</span>
                        <Divider />
                        <Collapse accordion defaultActiveKey={defaultActiveReleaseNote} items={relnotes} />
                    </>
                }
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        labels: uistate.selectors.uiLabels(state),
        curLanguage: uistate.selectors.curLanguage(state),
    };
}

export default connect(mapStateToProps,
    {
        loadReleaseNotes
    })(ReleaseNotesStartScreen);
